import { FC } from 'react'
import cn from 'classnames'
import styles from './Title.module.scss'

interface TitleProps {
  className?: string
  title: string
}
export const Title: FC<TitleProps> = ({ className, title }) => {
  return <h2 className={cn(className, styles.container)}>{title}</h2>
}
